import ScrollSpy from "react-scrollspy-navigation";

interface IProps {
  data: IGetMatIntegrationConfigurationRS;
}

const MatConfigurationSidebar = ({ data }: IProps) => {
  const { data: sections } = data;

  const renderSidebarItems = () =>
    sections.map(({ title }, index) => (
      <a
        key={index}
        href={`#${title}-section`}
        className="block w-full border-l-2 border-gray-light pl-20 p-10 font-medium transition-all hover:border-primary-light hover:bg-gray-light/30">
        {title}
      </a>
    ));

  return (
    <div className="sticky top-[70px] block max-h-max w-full">
      <ScrollSpy activeClass="border-primary bg-primary-light/30">
        {renderSidebarItems()}
      </ScrollSpy>
    </div>
  );
};

export default MatConfigurationSidebar;
